export default __webpack_public_path__ + "static/PMG_EGIB_HOHH_PDS_AGENCY_ENG-54f7cb676f08147b6a4d97ca9f31096a.pdf";